import { render, staticRenderFns } from "./Trails.vue?vue&type=template&id=1516c0fa&scoped=true&"
import script from "./Trails.vue?vue&type=script&lang=js&"
export * from "./Trails.vue?vue&type=script&lang=js&"
import style0 from "./Trails.vue?vue&type=style&index=0&id=1516c0fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516c0fa",
  null
  
)

export default component.exports